import { BaseNavigatorCommand } from "./BaseNavigatorCommand";
import { ConfigGetItemCommand } from "./ConfigGetItemCommand";

export class ConfigGetCommand extends BaseNavigatorCommand
{
    constructor(argv: string[], keys: string[])
    {
        let commnads: { [key: string]: any } = {};
        keys.forEach(key =>
        {
            commnads[key] = (argv: string[]) => new ConfigGetItemCommand(argv, key)
        });
        super(argv, commnads);
    }
}